import React, { useState, useEffect } from 'react'
import { Table,Space, Typography, Image, Form, Input, Popconfirm } from 'antd'
import { useSelector } from 'react-redux'
import { mailer } from './sendMail'
import { db } from '../../firebase'
import moment from 'moment'
import swal from 'sweetalert'
import { Redirect } from 'react-router-dom'

const { Text, Title } = Typography

function Approval() {
    const [form] = Form.useForm();
    const [editingKey, setEditingKey] = useState('');
    const users = useSelector(state => state.users)
    const auth = useSelector(state => state.auth)

    const isEditing = (record) => record._id === editingKey;

    const approveUser = record => {
      swal("Approve Registration?", "", "info")
        .then(() => {
          mailer(record.email, "Megawide – 2021 Annual Stockholders’ Meeting", "approve") 
        })
    }

    const rejectUser = record => {
      swal({
        title: 'Reject Registration',
        text: 'Remarks for rejection of registration',
        icon: 'warning',
        content: 'input',
        button: {
          text: 'Submit',
          closeModal: false
        }
      })
      .then(remarks => {
        if(!remarks) throw null;
        const data = { ...record }
        data.remarks = remarks

        db.collection('users').doc(record._id).set(data)
          .then(res => {
            swal("Done", "Registration Rejected", "success")
            mailer(record.email, "Megawide – 2021 Annual Stockholders’ Meeting", "reject", remarks)
          })
          .catch(err => swal("Oops!", "Something went wrong", "error"))
      })
      .catch(err => {
        if (err) {
          swal("Oh noes!", "The AJAX request failed!", "error");
        } else {
          swal.stopLoading();
          swal.close();
        }
      });
    }

    const edit = (record) => {
        form.setFieldsValue({
            noOfShares: '',
            ...record,
        });
        setEditingKey(record._id);
    };
    
    const cancel = () => {
        setEditingKey('');
    };

    const save = async (key) => {
        try {
            const row = await form.validateFields();
            const newData = [...users];
            const index = newData.find((datum) => datum._id === key)
            index.noOfShares = row.noOfShares

            db.collection('users').doc(key).set(index)
            setEditingKey('');
        } catch (errInfo) {
            console.log('Validate Failed:', errInfo);
        }
      };

    const columns = [
        {
            title: "Email",
            dataIndex: "email",
            key: "email",
            width: '200px'
        },
        {
            title: "Individual Name / Corporate Name",
            dataIndex: "fullname",
            key: "fullname",
            width: '350px'
        },
        {
          title: "Type",
          dataIndex: "accountType",
          key: "accountType",
          width: '350px'
        },
        {
            title: "Address",
            dataIndex: "address",
            key: "address",
            width: '350px'
        },
        {
            title: "Phone Number",
            dataIndex: "phoneNumber",
            key: "phoneNumber",
            width: '200px'
        },
        {
            title: "Mobile Number",
            dataIndex: "mobileNumber",
            key: "mobileNumber",
            width: '200px'
        },
        {
            title: "Scanned copy of the Secretary's Certificate or Board Resolution authorizing the representative of the corporation to cast the vote.",
            dataIndex: "authorizationLetter",
            key: "authorizationLetter",
            width: '250px',
            render: (text, record) => {
                return typeof text !== "undefined" ? (
                    <Typography.Link href={text} target="_blank">Click to View</Typography.Link>
                ) : (<></>)
            }
        },
        {
          title: "Broker's Certification (For Stockholders under Broker Accounts).",
          dataIndex: "brokerCertification",
          key: "brokerCertification",
          width: '250px',
          render: (text, record) => {
              return typeof text !== "undefined" ? (
                  <Typography.Link href={text} target="_blank">Click to View</Typography.Link>
              ) : (<></>)
          }
      },
        {
            title: "Current photograph of the representative authorized to cast the vote for the corporation, with face fully visible.",
            dataIndex: "photo",
            key: "photo",
            width: '250px',
            render: (text, record) => {
                return (
                    <Image src={text}/>
                )
            }
        },
        {
            title: "Scanned copy of valid government-issued ID of the authorized representative.",
            dataIndex: "govtId",
            key: "govtId",
            width: '250px',
            render: (text, record) => {
                return (
                    <Image src={text}/>
                )
            }
        },
        {
            title: "Total Number of Shares",
            dataIndex: 'noOfShares',
            key: 'noOfShares',
            editable: true,
            width: '200px'
        },
        {
            title: "Validated",
            dataIndex: 'isApproved',
            key: 'isApproved',
            width: '100px',
            render: (text, record) => {
              if(text) return (<Text type="success">Validated</Text>)
              if(record.remarks === null) return (<Text type="warning">Pending</Text>)
              return (<Text type="danger">Rejected</Text>)
            },
        },
        {
            title: "Reject Remarks",
            dataIndex: 'remarks',
            key: 'remarks',
            width: '250px',
        },
        {
            title: "Date Registered",
            dataIndex: "dateRegistered",
            key: "dateRegistered",
            width: "200px",
            sorter: (a, b) => moment(a.dateRegistered).unix() - moment(b.dateRegistered).unix(),
            sortDirections: ['descend'],
            defaultSortOrder: 'descend',
            render: (text) => {
              return(moment(text).format("MM-DD-YYYY hh:mm:ss A"))
            }
        },
    ]

    if(auth.type === 'Approver') {
      columns.push({
        title: "Action",
        key: "action",
        width: "150px",
        fixed: "right",
        render: (_, record) => {
          const editable = isEditing(record);
          return editable ? (
              <span>
                <a
                  href="javascript:;"
                  onClick={() => save(record._id)}
                  style={{
                    marginRight: 8,
                  }}
                >
                  Save
                </a>
                <Popconfirm title="Sure to cancel?" onConfirm={cancel}>
                  <a>Cancel</a>
                </Popconfirm>
              </span>
            ) : ( 
            <Space>
              <Typography.Link disabled={editingKey !== ''} onClick={() => edit(record)} disabled={record.isApproved || record.remarks !== null ? true : false} >
                  Edit
              </Typography.Link>
              <Typography.Link onClick={() => approveUser(record)} disabled={record.noOfShares === null || record.isApproved || record.remarks !== null ? true : false}>
                Approve
              </Typography.Link>
              <Typography.Link onClick={() => rejectUser(record)} disabled={record.isApproved || record.remarks !== null ? true : false} >
                Reject
              </Typography.Link>
            </Space>
          );
        },
      })
    }

    const mergedColumns = columns.map((col) => {
        if (!col.editable) {
          return col;
        }
    
        return {
          ...col,
          onCell: (record) => ({
            record,
            inputType: 'text',
            dataIndex: col.dataIndex,
            title: col.title,
            editing: isEditing(record),
          }),
        };
    });

    const EditableCell = ({
        editing,
        dataIndex,
        title,
        inputType,
        record,
        index,
        children,
        ...restProps
      }) => {
        const inputNode = <Input type="number" />;
        return (
          <td {...restProps}>
            {editing ? (
              <Form.Item
                name={dataIndex}
                style={{
                  margin: 0,
                }}
              >
                {inputNode}
              </Form.Item>
            ) : (
              children
            )}
          </td>
        );
    };

    return (
        <div>
            {
              auth.isLoggedIn ? (
                <>
                  <Title style={{ color: '#2B2C2B' }}>ASM Registration Corporate (Responses)</Title>
                  <Form form={form} component={false}>
                    <Table 
                        components={{
                            body: {
                                cell: EditableCell
                            }
                        }}
                        columns={mergedColumns} 
                        dataSource={users} 
                        scroll={{ x: 1920 }} 
                        size="small" 
                        bordered
                    />
                  </Form>
                </>
              ) : (<Redirect to="/" />)
            }
        
        </div>
    )
}

export default Approval
